import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VApp,
    [
      _c(
        "CoreDialog",
        {
          attrs: {
            "data-qa": "banner-mt-link-modal",
            size: "fullscreen",
            "content-class": "mtlink-modal",
            persistent: "",
          },
          scopedSlots: _vm._u([
            {
              key: "prependBtn",
              fn: function ({ btnProps }) {
                return [
                  _c(
                    VBtn,
                    _vm._b(
                      { on: { click: _vm.handleCloseModal } },
                      "v-btn",
                      btnProps,
                      false
                    ),
                    [_c("span", { staticClass: "ui-icon-close-not-a-circle" })]
                  ),
                ]
              },
            },
            {
              key: "actions",
              fn: function () {
                return [
                  _c(
                    VBtn,
                    {
                      attrs: {
                        "data-qa": "modal-actions-btn-confirm",
                        color: "primary",
                        block: "",
                        depressed: "",
                      },
                      on: { click: _vm.handleInstallApp },
                    },
                    [_vm._v("\n        Установить приложение\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    VBtn,
                    {
                      attrs: {
                        "data-qa": "modal-actions-btn-close",
                        color: "primary",
                        block: "",
                        text: "",
                      },
                      on: { click: _vm.handleCloseModal },
                    },
                    [_vm._v("\n        Закрыть\n      ")]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.isOpened,
            callback: function ($$v) {
              _vm.isOpened = $$v
            },
            expression: "isOpened",
          },
        },
        [
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex-grow-1" },
            [_c("BannerMtLinkSlider", { staticClass: "pb-2" })],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }